import React from 'react';
import { findIndex } from 'underscore';
import clone from 'clone';
import BuildActions from '../builder/action/builderActions';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';

class AdvancedSearchPanel extends React.Component {
  constructor(props) {
    super(props);
    this.valueIncrement = this.valueIncrement.bind(this);
    this.valueDecrement = this.valueDecrement.bind(this);
    this.showAdvacedOption = this.showAdvacedOption.bind(this);
    this.verticalSearch = this.verticalSearch.bind(this);
    this.horizontalSearch = this.horizontalSearch.bind(this);
    this.addSelected = this.addSelected.bind(this);
    this.dropdownTemplate = this.dropdownTemplate.bind(this);
    this.defaultTemplate = this.defaultTemplate.bind(this);
    this.handelCustomCss = this.handelCustomCss.bind(this);
    const indexType = findIndex(this.props.allLayout, { uid: this.props.uid });
    if (indexType !== -1) {
      this.state = { styleType: this.props.allLayout[indexType].styleType };
    } else {
      this.state = { styleType: '' };
    }
  }
  componentWillMount() {
    const allLayout = clone(this.props.allLayout);
    const find = findIndex(allLayout, { uid: this.props.uid });
    if (find !== -1) {
      const layout = parseInt(allLayout[find].layout, 10);
      const styleType = allLayout[find].styleType !== undefined ? allLayout[find].styleType : null;
      const styleTemplate = allLayout[find].styleTemplate !== undefined ? allLayout[find].styleTemplate : null;
      const customCssClass = allLayout[find].customCssClass !== undefined ? allLayout[find].customCssClass : null;
      this.setState({ rangeValue: layout, styleType, styleTemplate, customCssClass });
    }
  }
  valueDecrement() {
    let value = this.state.rangeValue;
    if ((value - 1) < 1) {
      return;
    }
    value -= 1;
    this.setState({ rangeValue: value });
    if (this.layoutType !== undefined) {
      this.setState({ errorMsg: null });
    }
  }
  addSelected(e) {
    e.preventDefault();
    const allLayout = clone(this.props.allLayout);
    const indexOfSearch = findIndex(allLayout, { uid: this.props.uid });
    if (allLayout[indexOfSearch].styleType !== this.state.styleType
      || parseInt(allLayout[indexOfSearch].layout, 10) !== this.state.rangeValue
      || allLayout[indexOfSearch].styleTemplate !== this.state.styleTemplate || allLayout[indexOfSearch].customCssClass !== this.state.customCssClass) {
      const find = findIndex(allLayout, { uid: this.props.uid });
      if (find !== -1) {
        allLayout[find].styleType = this.state.styleType;
        allLayout[find].layout = this.state.rangeValue;
        allLayout[find].styleTemplate = this.state.styleTemplate;
        allLayout[find].customCssClass = this.state.customCssClass;
      }
      const pushLayout = {
        allLayout,
        'shortcodeKey': this.props.shortcodeKey,
      };
      BuildActions.saveAllBlocks(pushLayout);
      this.props.onClickedPanel();
    }
  }
  valueIncrement() {
    let value = this.state.rangeValue;
    if ((value + 1) > 12) {
      return;
    }
    value += 1;
    this.setState({ rangeValue: value });
    if (this.layoutType !== undefined) {
      this.setState({ errorMsg: null });
    }
  }
  showAdvacedOption(e) {
    e.preventDefault();
    this.setState({ showAdvacedOption: !this.state.showAdvacedOption });
  }
  verticalSearch(e) {
    e.preventDefault();
    this.setState({ styleType: 'vertical' });
  }
  horizontalSearch(e) {
    e.preventDefault();
    this.setState({ styleType: 'horizontal' });
  }
  defaultTemplate(e) {
    e.preventDefault();
    this.setState({ styleTemplate: 'default' });
  }
  dropdownTemplate(e) {
    e.preventDefault();
    this.setState({ styleTemplate: 'dropdown' });
  }
  handelCustomCss(e) {
    e.preventDefault();
    this.setState({ customCssClass: e.target.value });
  }
  render() {
    const customStyleClass = this.state.styleType === 'horizontal' ? 'horizontalactive' : 'verticalactive';
    const customTemplateClass = this.state.styleTemplate === 'dropdown' ? 'horizontalactive' : 'verticalactive';
    return (<div>
      <div className="advancedsearchmodal">
        <div className="for-search-panel grid-choose-option">
          <div className="">
            <div className="flex-row bottom-panel-search">
              <div className="flex-md-7 flex-sm-6 flex-xs-12">
                <div className=" grid-choose-option from-search-panel">
                  <span className="caption">{API.LANG.ADVANCE_SETTINGS}:</span>
                  <div className="search-view-type-change">
                    <ReactCSSTransitionGroup transitionName="simplefade" transitionEnterTimeout={200} transitionLeaveTimeout={200}>
                      <p className={customStyleClass}>
                        <a href="#" className="vertical" onClick={this.verticalSearch}>{API.LANG.VERTICAL}</a>
                        <a href="#" className="horizontal" onClick={this.horizontalSearch}>{API.LANG.HORIZONTAL}</a>
                      </p>
                    </ReactCSSTransitionGroup>
                  </div>
                </div>
              </div>
              <div className="flex-md-7 flex-sm-6 flex-xs-12">
                <div className=" grid-choose-option from-search-panel">
                  <span className="caption">{API.LANG.TEMPLATE_SETTINGS}:</span>
                  <div className="search-view-type-change">
                    <ReactCSSTransitionGroup transitionName="simplefade" transitionEnterTimeout={200} transitionLeaveTimeout={200}>
                      <p className={customTemplateClass}>
                        <a href="#" className="vertical" onClick={this.defaultTemplate}>{API.LANG.DEFAULT}</a>
                        <a href="#" className="horizontal" onClick={this.dropdownTemplate}>{API.LANG.DROPDOWN}</a>
                      </p>
                    </ReactCSSTransitionGroup>
                  </div>
                </div>
              </div>
              <div className="flex-md-12 flex-sm-12 flex-xs-12">
                <div className="grid-choose-option from-search-panel">
                  <span className="caption">{API.LANG.CUSTOM_CLASS}:</span>
                  <div className="search-view-type-change custom-class-content">
                    <input type="text" className="reactive-input" placeholder={API.LANG.PLACE_ENTER_ANY_CLASS_NAME} value={this.state.customCssClass} onChange={this.handelCustomCss}/>
                  </div>
                </div>
              </div>
              <div className="flex-md-12 flex-sm-12 flex-xs-12">
                <div className="grid-choose-option from-search-panel">
                  <span className="caption">{API.LANG.CHANGE_GRID_LAYOUT}</span>
                  <div className="choose-grid-button">
                    <p><button onClick={ this.valueIncrement }><i className="fa fa-plus"></i></button></p>
                    <p><button onClick={ this.valueDecrement }><i className="fa fa-minus"></i></button></p>
                    <p className="gird-value-count">
                      { this.state.rangeValue !== undefined ? this.state.rangeValue : null }
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="add-button-content">
         { this.state.errorMsg !== undefined ? <p className="error-body">{this.state.errorMsg}</p> : null }
          <a href="#" className="add-button" onClick={this.addSelected}> {API.LANG.SAVE} </a>
        </div>
      </div>
    </div>);
  }
}
AdvancedSearchPanel.propTypes = {
  'shortcodeKey': React.PropTypes.number,
  'uid': React.PropTypes.string,
  'allLayout': React.PropTypes.array,
  'onClickedPanel': React.PropTypes.func,
};

export default AdvancedSearchPanel;



/** WEBPACK FOOTER **
 ** ./assets/src/frontend/panel/advancedsearchpanel.js
 **/